import ctl from "@netlify/classnames-template-literals";

export const cardBottom = ctl(`
  flex
  h-full
  flex-col
  bg-white
  p-4
`);
